import { CurrencyEnum } from '@codezo/graphql';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { cn } from '../lib/utils';
import { CURRENCY_INFO, useCurrencyStore } from '../stores/currency';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const ALL_CURRENCIES = Object.values(CurrencyEnum);

export function CurrencySelector() {
	const { selectedCurrency, setCurrency } = useCurrencyStore();
	const [open, setOpen] = useState(false);

	const info = CURRENCY_INFO[selectedCurrency];

	const handleSelect = (currency: CurrencyEnum) => {
		setCurrency(currency);
		setOpen(false);
	};

	const renderItem = (code: CurrencyEnum) => {
		const ci = CURRENCY_INFO[code];
		const isSelected = selectedCurrency === code;
		return (
			<button
				key={code}
				onClick={() => handleSelect(code)}
				className={cn(
					'relative flex w-full cursor-pointer items-center gap-2.5 rounded-md px-2.5 py-2 text-left text-sm transition-colors',
					isSelected
						? 'bg-surface-fill text-text-1'
						: 'text-text-2 hover:bg-surface-hover hover:text-text-1'
				)}
			>
				{isSelected && (
					<span className="absolute left-0 top-1/4 bottom-1/4 w-1 rounded-sm bg-accent" />
				)}
				<span className="w-5 text-center text-base leading-none">{ci.flag}</span>
				<span className="flex-1 font-medium">{ci.code.toUpperCase()}</span>
				<span className="text-xs text-text-4">{ci.name}</span>
			</button>
		);
	};

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger
				className={cn(
					'inline-flex h-7 cursor-pointer items-center gap-1.5 rounded-md border border-transparent px-2 text-sm font-medium transition-colors',
					open
						? 'border-line-1 bg-surface-fill text-text-1'
						: 'text-text-2 hover:bg-surface hover:text-text-1'
				)}
			>
				<span className="text-base leading-none">{info.flag}</span>
				<span>{info.code.toUpperCase()}</span>
				<ChevronDown
					size={11}
					className={cn('text-text-4 transition-transform', open && 'rotate-180')}
				/>
			</PopoverTrigger>
			<PopoverContent align="end" className="w-[240px] gap-0 p-0">
				<div className="p-1.5">{ALL_CURRENCIES.map(renderItem)}</div>
			</PopoverContent>
		</Popover>
	);
}
